import moment from 'moment-timezone';

// The carrier shape shared with OfferDateTimeField/offerDateTimeFieldLogic.ts -- local to this
// operator's browser, never what crosses the wire to aux-api (that is ISO 8601, see below).
const LOCAL_WALL_CLOCK_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// What aux-api's ISO_UTC_FORMAT accepts -- standard ISO 8601 UTC, matching Date#toISOString()'s
// own output exactly, so nothing on either side hand-rolls a second description of this shape.
export const WIRE_FORMAT_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

// Strict + explicit format rejects a malformed value instead of moment's deprecated free-text
// fallback, which would otherwise produce the literal, savable string "Invalid date".
export function zonedWallClockToUtc(wallClock: string, timeZone: string): string {
  if (!wallClock) {
    return wallClock;
  }
  const parsed = moment.tz(wallClock, LOCAL_WALL_CLOCK_FORMAT, true, timeZone);
  return parsed.isValid() ? parsed.utc().toISOString() : '';
}

export function utcToZonedWallClock(utc: string, timeZone: string): string {
  if (!utc) {
    return utc;
  }
  const parsed = moment.utc(utc, moment.ISO_8601, true);
  return parsed.isValid() ? parsed.tz(timeZone).format(LOCAL_WALL_CLOCK_FORMAT) : '';
}

export function getDeviceTimeZone(): string {
  return moment.tz.guess();
}

export function listTimeZoneNames(): string[] {
  return moment.tz.names();
}

export function formatTimeZoneOptionLabel(timeZone: string): string {
  return `${timeZone} (UTC${moment.tz(timeZone).format('Z')})`;
}

export function formatOfferListDateTime(utc: string | null | undefined, timeZone: string): string {
  if (!utc) {
    return '';
  }
  const parsed = moment.utc(utc, moment.ISO_8601, true);
  return parsed.isValid() ? parsed.tz(timeZone).format('YYYY-MM-DD HH:mm z') : '';
}
